module.exports = __webpack_public_path__ + "static/scale-model-of-phillips-park-zoo-in-aurora-illinois-3da4ab811dc79f89306416e2264399de.png";